import * as React from 'react'
import { draft } from '$utils/services/formDraftService'
import { broadcastFormDraftName, broadcastFormSteps } from '$views/RecommendationsForms/BroadcastForm/BroadcastForm'
import { Field } from 'formik'
import { FormiikField } from '$views/components/Forms/FormiikField'

export const PhoneNumber: React.FC<Props> = () => {
  const onBlur = event => {
    draft.set(broadcastFormDraftName, {
      [event.currentTarget.name]: event.currentTarget.value,
    })
  }

  return (
    <>
      <Field
        name={broadcastFormSteps.serviceInformationStep.phoneNumber}
        placeholder={'Tu número de teléfono'}
        type="tel"
        primary
        component={FormiikField}
        onBlur={onBlur}
        maxLength={15}
      />
    </>
  )
}



// WEBPACK FOOTER //
// ./src/views/RecommendationsForms/BroadcastForm/components/PhoneNumber/PhoneNumber.tsx